// Utils
import {
    getConfig,
} from '@shared/utils/config';

// Types
import {
    GatewayAuthData,
} from '@shared/types/auth';
import type {
    RegulationType,
    UserRegulatoryRestrictionLimitsFormatted,
} from '@shared/store/modules/wallet/types';

type WithdrawalLimits = Pick<UserRegulatoryRestrictionLimitsFormatted, RegulationType.Withdrawal>;

type WithdrawalGatewayParams = GatewayAuthData & {
    currency: Record<string, unknown>;
    limits: WithdrawalLimits;
    webApp?: boolean;
};

export const getWithdrawalGatewayURL = ({
    deviceId = '',
    currency = {},
    limits = <WithdrawalLimits>{},
    ...params
}: WithdrawalGatewayParams) => {
    const baseUrl = getConfig().paymentGatewayUrl;

    return Object.entries({
        deviceUid: deviceId,
        type: 'withdrawal',
        currency: JSON.stringify(currency),
        limits: JSON.stringify(limits),
        ...params,
    }).reduce((acc, [key, value], index) => `${acc}${index > 0 ? '&' : '?'}${key}=${encodeURIComponent(value)}`, `${baseUrl}/withdrawal`);
};